<template>
    <router-link class="search-result-text pt-3 pb-3" :to="`/blog/${item.slug}`" :title="item.title" rel="nofollow">
        <div class="d-flex title-container align-items-start">
            <UIIcon :name="['fal', 'newspaper']" class="icon mr-2 font-weight-bold"></UIIcon>
            <div class="title font-weight-bold">{{ item.title }}</div>
        </div>
        <p class="intro mb-0">{{ introText }}</p>
    </router-link>
</template>

<script>
import { UIIcon } from '@dundle/ui/components';

export default {
    components: {
        UIIcon,
    },
    props: ['item'],

    computed: {
        introText() {
            return this.item.content ? `${this.item.content.value}...` : '...';
        },
    },
};
</script>

<style lang="scss" scoped>
.search-result-text {
    display: block;
    background-color: #fff;
    border-bottom: 1px solid $color-grey-3;
    color: $color-text;

    .icon {
        margin-top: 0.2rem;
    }

    @media screen and (max-width: 768px) {
        padding: 0 15px;
        border-top: 10px solid $color-grey-1;
    }

    &:hover {
        background-color: $color-primary-light;
        text-decoration: none;
    }

    .intro {
        display: block;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
